import Box from '@mui/material/Box';
import { SectionTitle, Subsection } from '../components/SectionPrimitives';

export function Section4(): JSX.Element {
  return (
    <Box>
      <SectionTitle>4. Cancellation</SectionTitle>

      <Subsection title="4.1 Vineyard Listing Agreements">
        Partners may cancel the renewal of the Agreement prior to the renewal
        date. Upon cancellation, UKVG services will continue until the original
        renewal date, unless otherwise agreed in writing. No partial refunds
        will be issued once the subscription period has commenced unless
        required by law, including the Consumer Rights Act 2015.
      </Subsection>

      <Subsection title="4.2 Commercial Partnership Agreements">
        Partners may cancel the renewal of the Agreement prior to the renewal
        date. Upon cancellation, UKVG services will continue until the original
        renewal date, unless otherwise agreed in writing. No partial refunds
        will be issued once the agreement period has commenced unless required
        by law, including the Consumer Rights Act 2015.
      </Subsection>

      <Subsection title="4.3 Consumer Cancellation Rights">
        Where a Partner is a sole trader or individual rather than a limited
        company, and has not received any services under the Agreement, they may
        be entitled to a 14-day cancellation period in accordance with the
        Consumer Contracts (Information, Cancellation and Additional Charges)
        Regulations 2013. This right to cancel is lost once services have
        commenced with the Partner's express consent.
      </Subsection>

      <Subsection title="4.4 Termination by UKVG">
        UKVG may suspend or terminate an Agreement in the event of a breach of
        these Terms, the provision of misleading information by the Partner, or
        illegal activity by the Partner.
      </Subsection>
    </Box>
  );
}
